import { buildUrlForServiceName } from '@/connection/url-retriever';
import conf from '@/shared/config/useConfig';

export const useAssets = () => {
  const assetsBaseUrl = `${buildUrlForServiceName(conf.partnerserviceName)}`;

  const holeAssetContext = (): string => {
    return `${assetsBaseUrl}/partnerservice`;
  };

  return {
    holeAssetContext,
  };
};
